import lottie from 'lottie-web';
import React, { memo, forwardRef, useRef, useState, useEffect, useCallback } from 'react';
import equal from 'fast-deep-equal/es6/react';
import clone from 'rfdc/default';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b = "function" === typeof Symbol && Symbol.for,
  c = b ? Symbol.for("react.element") : 60103,
  d = b ? Symbol.for("react.portal") : 60106,
  e = b ? Symbol.for("react.fragment") : 60107,
  f = b ? Symbol.for("react.strict_mode") : 60108,
  g = b ? Symbol.for("react.profiler") : 60114,
  h = b ? Symbol.for("react.provider") : 60109,
  k = b ? Symbol.for("react.context") : 60110,
  l = b ? Symbol.for("react.async_mode") : 60111,
  m = b ? Symbol.for("react.concurrent_mode") : 60111,
  n = b ? Symbol.for("react.forward_ref") : 60112,
  p = b ? Symbol.for("react.suspense") : 60113,
  r = b ? Symbol.for("react.memo") : 60115,
  t = b ? Symbol.for("react.lazy") : 60116;
function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;
              default:
                return u;
            }
        }
      case d:
        return u;
    }
  }
}
function A(a) {
  return z(a) === m;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }

    // Detect buggy property enumeration order in older V8 versions.

    // https://bugs.chromium.org/p/v8/issues/detail?id=4118
    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
    test1[5] = 'de';
    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    }

    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });
    if (order2.join('') !== '0123456789') {
      return false;
    }

    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }
    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;
var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function printWarning() {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has;
  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {/**/}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};
if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function printWarning$1(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull() {
  return null;
}
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var defaultProps = {
  animationData: null,
  path: null,
  play: null,
  segments: null,
  goTo: null,
  useSubframes: true,
  speed: 1,
  direction: 1,
  loop: true,
  rendererSettings: {},
  renderer: 'svg',
  audioFactory: null,
  onLoad: function onLoad() {},
  onComplete: function onComplete() {},
  onLoopComplete: function onLoopComplete() {},
  onEnterFrame: function onEnterFrame() {},
  onSegmentStart: function onSegmentStart() {}
};
var makeLottiePlayer = function makeLottiePlayer(_ref) {
  var loadAnimation = _ref.loadAnimation;
  var Lottie = memo(forwardRef(function (_ref2, forwardedRef) {
    var animationData = _ref2.animationData,
      path = _ref2.path,
      play = _ref2.play,
      speed = _ref2.speed,
      direction = _ref2.direction,
      segmentsIn = _ref2.segments,
      goTo = _ref2.goTo,
      useSubframes = _ref2.useSubframes,
      renderer = _ref2.renderer,
      loop = _ref2.loop,
      rendererSettingsIn = _ref2.rendererSettings,
      audioFactory = _ref2.audioFactory,
      onLoad = _ref2.onLoad,
      onComplete = _ref2.onComplete,
      onLoopComplete = _ref2.onLoopComplete,
      onEnterFrame = _ref2.onEnterFrame,
      onSegmentStart = _ref2.onSegmentStart,
      props = _objectWithoutPropertiesLoose(_ref2, ["animationData", "path", "play", "speed", "direction", "segments", "goTo", "useSubframes", "renderer", "loop", "rendererSettings", "audioFactory", "onLoad", "onComplete", "onLoopComplete", "onEnterFrame", "onSegmentStart"]);
    var animElementRef = useRef();
    var animRef = useRef();
    var _useState = useState(false),
      ready = _useState[0],
      setReady = _useState[1];
    var _useState2 = useState(segmentsIn),
      segments = _useState2[0],
      setSegments = _useState2[1];
    useEffect(function () {
      if (!equal(segments, segmentsIn)) setSegments(segmentsIn);
    }, [segmentsIn, segments]);
    var _useState3 = useState(rendererSettingsIn),
      rendererSettings = _useState3[0],
      setRendererSettings = _useState3[1];
    useEffect(function () {
      if (!equal(rendererSettings, rendererSettingsIn)) setRendererSettings(rendererSettingsIn);
    }, [rendererSettingsIn, rendererSettings]);
    useEffect(function () {
      return function () {
        return animRef.current.removeEventListener('complete', onComplete);
      };
    }, [onComplete]);
    useEffect(function () {
      return function () {
        return animRef.current.removeEventListener('loopComplete', onLoopComplete);
      };
    }, [onLoopComplete]);
    useEffect(function () {
      return function () {
        return animRef.current.removeEventListener('enterFrame', onEnterFrame);
      };
    }, [onEnterFrame]);
    useEffect(function () {
      return function () {
        return animRef.current.removeEventListener('segmentStart', onSegmentStart);
      };
    }, [onSegmentStart]);
    useEffect(function () {
      return function () {
        return animRef.current.removeEventListener('DOMLoaded', onLoad);
      };
    }, [onLoad]);
    var setLottieRefs = useCallback(function (newRef) {
      animRef.current = newRef;
      if (forwardedRef) forwardedRef.current = newRef;
    }, []);
    useEffect(function () {
      function parseAnimationData() {
        if (animationData == null || typeof animationData !== 'object') return animationData;
        if (typeof animationData["default"] === 'object') {
          return clone(animationData["default"]);
        }
        return clone(animationData);
      }
      var lottie = loadAnimation({
        animationData: parseAnimationData(),
        path: path,
        container: animElementRef.current,
        renderer: renderer,
        loop: false,
        autoplay: false,
        rendererSettings: rendererSettings,
        audioFactory: audioFactory
      });
      setLottieRefs(lottie);
      var onDomLoaded = function onDomLoaded() {
        return setReady(true);
      };
      animRef.current.addEventListener('DOMLoaded', onDomLoaded);
      return function () {
        animRef.current.removeEventListener('DOMLoaded', onDomLoaded);
        setReady(false);
        animRef.current.destroy();
        setLottieRefs(undefined);
      };
    }, [loop, renderer, rendererSettings, animationData, path, audioFactory, setLottieRefs]);
    useEffect(function () {
      animRef.current.addEventListener('DOMLoaded', onLoad);
    }, [onLoad]);
    useEffect(function () {
      animRef.current.addEventListener('complete', onComplete);
    }, [onComplete]);
    useEffect(function () {
      animRef.current.addEventListener('loopComplete', onLoopComplete);
    }, [onLoopComplete]);
    useEffect(function () {
      animRef.current.addEventListener('enterFrame', onEnterFrame);
    }, [onEnterFrame]);
    useEffect(function () {
      animRef.current.addEventListener('segmentStart', onSegmentStart);
    }, [onSegmentStart]);
    useEffect(function () {
      if (!ready) return;
      animRef.current.loop = loop;
    }, [ready, loop]);
    var wasPlayingSegmentsRef = useRef(false);
    useEffect(function () {
      if (!ready) return;
      function playReverse(lastFrame) {
        animRef.current.goToAndPlay(lastFrame, true);
        animRef.current.setDirection(direction);
      }
      if (play === true) {
        var force = true;
        if (segments) {
          animRef.current.playSegments(segments, force);
          wasPlayingSegmentsRef.current = true;
          if (direction === -1) {
            var lastFrame = segments[1];
            playReverse(lastFrame);
          }
        } else {
          if (wasPlayingSegmentsRef.current) animRef.current.resetSegments(force);
          wasPlayingSegmentsRef.current = false;
          if (direction === -1) {
            var _lastFrame = animRef.current.getDuration(true);
            playReverse(_lastFrame);
          } else {
            animRef.current.play();
          }
        }
      } else if (play === false) {
        animRef.current.pause();
      }
    }, [play, segments, ready, direction]);
    useEffect(function () {
      if (!ready) return;
      if (Number.isNaN(speed)) return;
      animRef.current.setSpeed(speed);
    }, [speed, ready]);
    useEffect(function () {
      if (!ready) return;
      animRef.current.setDirection(direction);
    }, [direction, ready]);
    useEffect(function () {
      if (!ready) return;
      if (goTo == null) return;
      var isFrame = true;
      if (play) animRef.current.goToAndPlay(goTo, isFrame);else animRef.current.goToAndStop(goTo, isFrame);
    }, [goTo, play, ready]);
    useEffect(function () {
      if (animRef.current.setSubframe) animRef.current.setSubframe(useSubframes);
    }, [useSubframes]);
    return /*#__PURE__*/React.createElement("div", _extends({}, props, {
      ref: animElementRef
    }));
  }));
  Lottie.defaultProps = defaultProps;
  return Lottie;
};
var LottiePlayer = makeLottiePlayer(lottie);
export default LottiePlayer;